import { SearchBarLarge, SearchBarSmall } from 'constants/componentsDimension';
import styled from 'styled-components';
import {
    List as MaestroList,
    spacing,
    Popper as MaestroPopper,
    palette,
} from '@landr/maestro';

export const ListIcon = styled(MaestroList.ItemIcon)`
    margin-right: ${spacing('xs')};
`;

export const List = styled(MaestroList)`
    width: ${SearchBarLarge};

    ${({ theme }): string => theme.breakpoint('ml')`
        width: ${SearchBarSmall};
        padding-top: ${spacing('xxs')};
    `}

    min-width: 100%;
    max-width: 100%;
    padding-bottom: ${spacing('sm')};
`;

export const Popper = styled(MaestroPopper)`
    background-color: ${palette('neutral.800')};
    border-bottom-left-radius: ${spacing('xl')};
    border-bottom-right-radius: ${spacing('xl')};
    overflow: hidden;
`;
